import {Loader2} from 'lucide-react'
import {cn} from '@/lib/utils'

interface PageSpinnerProps {
    className?: string
}

export function PageSpinner({className}: PageSpinnerProps) {
    return (
        <div className={cn('flex items-center justify-center py-12', className)}>
            <Loader2 data-testid="page-spinner" className="h-8 w-8 animate-spin text-muted-foreground"/>
        </div>
    )
}
